export default __webpack_public_path__ + "static/media/takePhoto.b4e2bf2d.png";